import { RootState } from "store";
import { useSelector } from "react-redux";
import { checkIsLoading, checkIsLoadingDone } from "common/utils/checkLoading";

import { CARS_STATE } from "../../constants";
import { useCallback, useMemo } from "react";

const useCarEBoxLocationsLoadingStatus = () => {
  const carsEBoxLocationsLoadingStatus = useSelector(
    (state: RootState) => state[CARS_STATE].eBoxLocations.loadingStatus
  );
  return carsEBoxLocationsLoadingStatus;
};

export const useIsCarEBoxLocationsLoading = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxLocationsLoadingStatus();
  return checkIsLoading(carEBoxLocationsLoadingStatus);
};

export const useIsCarEBoxLocationsDone = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxLocationsLoadingStatus();
  return checkIsLoadingDone(carEBoxLocationsLoadingStatus);
};

export const useCarEBoxLocations = () => (
  useSelector(
    (state: RootState) => state[CARS_STATE].eBoxLocations.data
  )
);

export const useCarObuSerialnumber = () => {
  const carEBoxLocations = useSelector(
    (state: RootState) => state[CARS_STATE].eBoxLocations.data
  );
  return carEBoxLocations?.map(({ obuNumber }) => obuNumber);
};

export const useCarObuSerialnumberByAutoNumber = () => {
  const carEBoxLocations = useSelector(
    (state: RootState) => state[CARS_STATE].eBoxLocations.data
  );
  return useCallback(
    (autoNumber: Nullable<string>) => {
      return carEBoxLocations?.find((data) => data.autoNumber === autoNumber);
    },
    [carEBoxLocations]
  );
};

export const useEBoxLocationByObuNumber = (obuNumber: string) => {
  const carEBoxLocations = useCarEBoxLocations();

  return useMemo(() => (
    (carEBoxLocations || []).find(item => item.obuNumber === obuNumber)
  ), [carEBoxLocations, obuNumber]);
};

export const useHasCarEBoxLocations = () => {
  const carEBoxLocations = useCarEBoxLocations() || [];
  return !!carEBoxLocations.length;
};
